import { PENDING, FULFILLED, REJECTED} from 'redux-promise-middleware';
import { ADD_SUPPLIER_FROM_SOCKET, GET_SUPPLIERS, ADD_GHOST_SUPPLIER, RESET_GHOST_SUPPLIER, RESET_SUPPLIER_ERROR } from '../actions/types';

const defaultState = {
	loading: false,
	data: false,
	map: false
}

export const suppliersReducer = (state = defaultState, action) => {

	switch(action.type){

		case ADD_SUPPLIER_FROM_SOCKET:

			const { supplier } = action;

			return {
				...state,
				data: [supplier ,...state.data]
			}

		case `${GET_SUPPLIERS}_${PENDING}`:
			return {
				loading:true,
				data: false
			}

		
		case `${GET_SUPPLIERS}_${FULFILLED}`:
			
			return {
				loading:false,
				data: action.payload.data.suppliers,
				map: action.payload.data.suppliers.reduce(
					(acc, cur) => {
						acc[cur._id] = cur;
						return acc;
					}, {}
				)
			}
		
		case `${GET_SUPPLIERS}_${REJECTED}`:
			
			return {
				loading:false			
			}



		default:
			return state;
	}

}

const defaultGhostSupplier = {
	loading: false,
	success: false,
	error: false
}

export const ghostSupplierReducer = (state = defaultGhostSupplier, action) => {

	switch(action.type){

		case `${ADD_GHOST_SUPPLIER}_${PENDING}`:
			return {
				...state,
				loading:true
			}

		
		case `${ADD_GHOST_SUPPLIER}_${FULFILLED}`:
			return {
				...state,
				loading:false,
				success: true
			}

		case `${ADD_GHOST_SUPPLIER}_${REJECTED}`:
			return {
				...state,
				loading:false,
				success: false,
				error: action.payload.response.data.err
			}
		
		case RESET_GHOST_SUPPLIER:
			return {
				...defaultGhostSupplier
			}

		case `${RESET_SUPPLIER_ERROR}`:
			return {
				...state,
				loading:false,
				success: false,
				error: false
			}

		default:
			return state;
	}

}


// WEBPACK FOOTER //
// ./src/components/supplier/reducers/index.js